import { trackEvent } from "@/lib/analytics-events";

function trackFreeToolCompleted(props: {
  tool_name: string;
  source_path?: string;
  language?: string;
  placement?: string;
  step?: string;
  has_time?: boolean;
}) {
  trackEvent("free_tool_completed", props);
}

export function trackKundaliFormStarted(props: {
  language: string;
  source?: string;
  source_path?: string;
  first_field?: string;
}) {
  trackEvent("kundali_form_started", props);
  trackEvent("free_tool_started", {
    tool_name: "free-kundali",
    language: props.language,
    source_path: props.source_path,
    placement: props.first_field,
  });
}

export function trackKundaliFormSubmitted(props: {
  language: string;
  has_time: boolean;
  source?: string;
  source_path?: string;
}) {
  trackEvent("kundali_form_submitted", props);
}

export function trackKundaliFormSubmitFailed(props: {
  language: string;
  has_time: boolean;
  source?: string;
  source_path?: string;
  error_message?: string;
}) {
  trackEvent("kundali_form_submit_failed", props);
}

export function trackKundaliResultViewed(props: {
  reading_id?: string;
  language: string;
  has_time: boolean;
  source?: string;
  source_path?: string;
  dosha_count?: number;
  product_count?: number;
}) {
  trackEvent("kundali_result_viewed", props);
}

export function trackKundaliGenerated(props: {
  language: string;
  has_time: boolean;
  source?: string;
  source_path?: string;
}) {
  trackEvent("kundali_generated", props);
  trackFreeToolCompleted({
    tool_name: "free-kundali",
    language: props.language,
    source_path: props.source_path,
    has_time: props.has_time,
  });
}
